export default __webpack_public_path__ + "static/blog-single-6556814d63aa7bc3ba05b77ea2cb42a6.png";